<template>
    <v-container grid-list-xs>
      

    <v-divider class="mt-12"></v-divider>
    <h3 class="text-center">Fotos - {{$route.params.nombre}}</h3>
          <p class="text-center">Codigo: {{$route.params.codigo}}</p>

    <v-divider></v-divider>
       <v-row class="mt-n5">
              <v-col cols="5" xs="5">
              <v-btn 
              block
              class="mx-auto"
              color="success" 
              dark @click="dialog=!dialog
              talla='',
              orden='',
              stock='',
               idtalla=''"
               >
              Agrega Talla </v-btn>
                </v-col>
              <v-col cols="5" xs="5">
              <v-btn 
              block
              class="mx-auto"
              color="error" 
              dark @click="dialogocolores=!dialogocolores" >
              Agrega color </v-btn>
              </v-col>
               <v-col cols="1" xs="1">
                  <v-btn icon color="red">
                  <v-icon
                  @click="dialogoFoto=!dialogoFoto">
                  fas fa-camera</v-icon>
                  </v-btn> 
               </v-col>             
                </v-row>

                    <v-divider></v-divider>


     
        
      <v-layout row wrap pa-2>
      <v-col
     v-for="color in filtracolor($route.params.padre)" :key="color"
    cols="2"
    xs="1"
    sm="2"
    md="1"> 
     <v-avatar :color="color.color" size="40" @click="eliminaColor($route.params.padre,color.idcolor)">
      <span class="white--text headline"></span>
    </v-avatar>
      </v-col>
       </v-layout>

       <v-layout row wrap pa-2>

      <v-col
     v-for="tallas in filtratallas($route.params.padre)" :key="tallas"
    cols="2"
    xs="1"
    sm="2"
    md="1"> 
         <v-badge
        :content="tallas.stock"
        :value="tallas.stock"
        color="green"
        overlap
      >
     <v-avatar color="orange"
      size="40"
       @click="dialog=!dialog,
       talla=tallas.talla,
       orden=tallas.orden
     stock=tallas.stock,
     idtalla=tallas.idtalla">
      <span class="white--text headline">{{tallas.talla}}</span>
    </v-avatar>
         </v-badge>
      </v-col>
        <v-flex xs12 class="pa-2">
   
                      
                        <v-row >
                          
                    <v-col
                        v-for="cate in filtra($route.params.padre)" :key="cate.foto"
                        cols="6"
                        xs="6"
                        sm="4"
                        md="3">

                        <v-card
                        class="pa-3 font-italic text-center"
                        outlined
                        tile
                        >
                                <v-img
                                :src="cate.foto"
                                aspect-ratio="1">
                                <template v-slot:placeholder>
                                    <v-row
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                    >
                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                </template>
                                <v-card-actions>
                                   <v-btn icon color="black"                                    
                                   @click="dialogoCodigo=!dialogoCodigo,
                                   uifotounica=cate.idfoto,
                                    codigounico=cate.codigounico,
                                    ubicacionunica=cate.ubicacionunica,
                                    tallaunica=cate.tallaunica,
                                   idfotoparadialogo=cate.idfoto">
                                <v-icon>fas fa-wrench</v-icon>
                                </v-btn>
                                </v-card-actions>

                                </v-img>
                           {{$route.params.codigo}} {{cate.codigounico}} - {{cate.tallaunica}}
                                
                        </v-card>
                    </v-col>
                    </v-row>
        </v-flex>
    </v-layout>

    <v-dialog
      v-model="dialogoCodigo"
      max-width="500"
    >
      <v-system-bar window dark>
        <v-icon @click="dialogoCodigo=!dialogoCodigo">mdi-close</v-icon>
      </v-system-bar>
    <v-card max-width="500" class="pa-3">
      <v-row class="mt-n5">
              <v-col cols="6" xs="6">
                      <v-text-field
                      label="Codigo(01)"
                      v-model="codigounico"
                    ></v-text-field>
              </v-col>
                <v-col cols="6" xs="6">
                  <v-text-field
                    label="Ubicacion"
                     v-model="ubicacionunica"
                  ></v-text-field>
              </v-col>
               
                  <v-text-field 
                  class="pa-3 mt-n4"
                    label="Talla"
                     v-model="tallaunica" 
                  ></v-text-field>
             <v-btn 
             class="mx-2"
             @click="grabardatosporfoto($route.params.padre,uifotounica),dialogoCodigo=false"
             color="success">Graba</v-btn>
             <v-spacer></v-spacer>
             <v-btn  icon color="red">
             <v-icon small
             @click="eliminar($route.params.padre,idfotoparadialogo),dialogoCodigo=false">fas fa-trash</v-icon>
              </v-btn>
      </v-row>

    </v-card>
    </v-dialog>


            <v-dialog
             v-model="dialog"
            max-width="500px"
            >
        <v-system-bar window dark>
        <v-icon @click="dialog=!dialog">mdi-close</v-icon>
      </v-system-bar>
      <v-card
        class="mx-auto pa-2"
        color="white"
        max-width="500px"
      >
          <v-form
              ref="form"
              class="pa-1"
              v-model="valid"
              lazy-validation
            >
             <v-row class="mt-n5">
              <v-col cols="4" xs="4">
              <v-text-field
                v-model="orden"
                :counter="8"
                :rules="Nombrerules"
                label="orden"
                required
              ></v-text-field>
              </v-col>
              <v-col cols="4" xs="4">
              <v-text-field
                v-model="talla"
                :counter="8"
                :rules="Nombrerules"
                label="Talla"
                required
              ></v-text-field>
              </v-col>
              <v-col cols="4" xs="4">
                <v-text-field
                v-model="stock"
                :counter="8"
                :rules="Nombrerules"
                label="Stock"
                required
              ></v-text-field>
              </v-col>
              </v-row>
            </v-form>
        <v-card-actions>
               <v-row class="mt-n5">
              <v-col cols="6" xs="6">
                          <v-btn
            block
          :disabled="!valid"
            color="success"
            class="mr-4"
            @click.stop="
            agregarTalla($route.params.padre,create_UUID())"
          >
            Guardar
          </v-btn>
                </v-col>
                <v-col cols="6" xs="6">
                            <v-btn
            block
          :disabled="!valid"
            color="error"
            class="mr-4"
            @click.stop="
            eliminarTalla($route.params.padre)"
          >
            eliminar
          </v-btn>
                </v-col>
                </v-row>


        </v-card-actions>
      </v-card>
     </v-dialog>


<v-dialog
            v-model="dialogoFoto"
            width="300"
            height="400"
            class="text-center mx-auto"
            transition="dialog-transition"
          >
                <v-system-bar window dark>
        <v-icon @click="dialogoFoto=!dialogoFoto">mdi-close</v-icon>
      </v-system-bar>
             <croppa
           width="300"
            height="400"
           class="text-center mx-auto black" 
           v-model="myCroppa"
           placeholder="Agrega Imagen"
          >  
          </croppa >
          <v-btn
          block
           color="error"
              @click="dialogoFoto=false,
               agregar($route.params.padre,create_UUID())"
              >graba</v-btn>
               <v-dialog
            v-model="progress"
            max-width="200"
            >
            <v-card>
                 <v-progress-circular
                  :rotate="90"
                  :size="200"
                  :width="15"
                  :value="Uploadvalue"
                  color="red"
                >
                  {{ Uploadvalue }}
                </v-progress-circular>
            </v-card>

         </v-dialog>
          </v-dialog>

     <v-dialog
      v-model="dialogocolores"
      max-width="490"
      >

    <v-row>
      <v-col
        class="d-flex justify-center"
      >
        <v-color-picker v-model="color"></v-color-picker>
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-sheet
          class="pa-4"
        >
          <v-btn
            :color="showColor"
            @click="dialogocolores=!dialogocolores,
            guardaColor($route.params.padre,create_UUID(),showColor)
            "
          >
            Guardar
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>

     </v-dialog>


      </v-container>

</template>

<script>
import { db } from '../db'
import store from '@/store/index'


  export default {
    name: 'gestionfotoscategoria',

    firebase:{
       categorias: db.database().ref("productosPadre")
    },
  
    data() {
        return {
          uifotounica:'',
          codigounico:'',
          ubicacionunica:'',
          tallaunica:'',
        dialogoCodigo:false,
        idfotoparadialogo:'',
        codigoactual:'',
        myCroppa:'',
        dialogoFoto:false,
        dialog:false,
        dialogocolores:false,
        categorias:[],
        progress: false,
        selectedFile:null,
        Uploadvalue:0,
        picture:null,
        valid: true,
        idfoto:'',
        talla: '',
        stock:'',
        idtalla:'',
        orden:'',

        types: ['hex', 'hexa', 'rgba', 'hsla', 'hsva'],
      type: 'hex',
      hex: '#FF00FF',
      hexa: '#FF00FFFF',
      rgba: { r: 255, g: 0, b: 255, a: 1 },
      hsla: { h: 300, s: 1, l: 0.5, a: 1 },
      hsva: { h: 300, s: 1, v: 1, a: 1 },
        }
      },
  
    
       methods: {
         grabardatosporfoto(nom,uuid){
           db.database().ref("productosPadre").child(nom).child("fotos").child(uuid).child("codigounico").set(this.codigounico)
           db.database().ref("productosPadre").child(nom).child("fotos").child(uuid).child("ubicacionunica").set(this.ubicacionunica)
           db.database().ref("productosPadre").child(nom).child("fotos").child(uuid).child("tallaunica").set(this.tallaunica)
           this.codigounico=''
           this.ubicacionunica=''
           this.tallaunica=''
         },
        obtenerIdentificador(li,ca,nom){
            var cate
            for(var i=0;i<this.categorias.length;i++){
                if(this.categorias[i].nombre==nom 
                && this.categorias[i].linea==li 
                && this.categorias[i].categoria==ca ){
                  return cate=this.categorias[i].identificador
                }
            }
               
        },
        filtra(padre){
            var cate
            for(var i=0;i<this.categorias.length;i++){
                if(this.categorias[i].identificador==padre){
                  return cate=this.categorias[i].fotos
                }
            }
               
        },
        filtracolor(padre){
            var cate
            for(var i=0;i<this.categorias.length;i++){
                if(this.categorias[i].identificador==padre){
                  return cate=this.categorias[i].color
                }
            }
               
        },
        filtratallas(padre){
            var cate 
            for(var i=0;i<this.categorias.length;i++){
                if(this.categorias[i].identificador==padre){
                  cate = this.categorias[i].talla
                }
            }
          return cate
        },

        agregar(nom,uuid){
            this.myCroppa.generateBlob(
                blob => {
                    this.progress = true
                  const storageRef = db.storage().ref(`/imagenesProductosPadre/${uuid}`)
                  const task=storageRef.put(blob)
                  task.on('state_changed',snapshot=>{
                    let porcentaje = (snapshot.bytesTransferred/snapshot.totalBytes)*100
                    this.Uploadvalue = porcentaje
                  },error=>{console.log(error.message)},
                  ()=>{this.Uploadvalue=100;
                        task.snapshot.ref.getDownloadURL().then((url)=>{
                          this.picture = url;
                   console.log("existe")
              db.database().ref("productosPadre").child(nom).child("fotos").child(uuid).child("idfoto").set(uuid)
              db.database().ref("productosPadre").child(nom).child("fotos").child(uuid).child("foto").set(this.picture)
                         
                          this.progress = false
                          console.log(this.picture)
                        })
                  })
         
         },
        'image/webp',
        0.8
      )
      
         },
            create_UUID(){
              var dt = new Date().getTime();
              var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                  var r = (dt + Math.random()*16)%16 | 0;
                  dt = Math.floor(dt/16);
                  return (c=='x' ? r :(r&0x3|0x8)).toString(16);
              });
              return uuid;
          },

        eliminar(nom,uuid){
             // Create a reference to the file to delete
              var desertRef = db.storage().ref(`/imagenesProductosPadre/${uuid}`)
              desertRef.delete().then(function() {
                  db.database().ref("productosPadre").child(nom).child("fotos").child(uuid).remove()
                console.log("exito")
              }).catch(function(error) {
                // Uh-oh, an error occurred!
                  console.log("fallo", error)
              });
            },

            guardaColor(nom,uuid,colorselecto){
              db.database().ref("productosPadre").child(nom).child("color").child(uuid).child("idcolor").set(uuid)
               db.database().ref("productosPadre").child(nom).child("color").child(uuid).child("color").set(colorselecto)
            },
            eliminaColor(nom,uuid){
              db.database().ref("productosPadre").child(nom).child("color").child(uuid).remove()
            },

            agregarTalla(nom,uuid){
              if(this.talla!='' && this.stock!=''){
              db.database().ref("productosPadre").child(nom).child("talla").child(this.orden+this.talla).child("idtalla").set(this.orden+this.talla)
              db.database().ref("productosPadre").child(nom).child("talla").child(this.orden+this.talla).child("talla").set(this.talla)
              db.database().ref("productosPadre").child(nom).child("talla").child(this.orden+this.talla).child("stock").set(this.stock)
              db.database().ref("productosPadre").child(nom).child("talla").child(this.orden+this.talla).child("orden").set(this.orden)
              
              this.talla=''
              this.stock=''
              this.orden=''
              this.dialog=!this.dialog
            }

            },
            eliminarTalla(nom){
         
              db.database().ref("productosPadre").child(nom).child("talla").child(this.orden+this.talla).remove()
              this.idtalla=''
              this.talla=''
              this.stock=''
              this.orden=''
              this.dialog=!this.dialog
             
            }
        },

        
    computed: {
      color: {
        get () {
          return this[this.type]
        },
        set (v) {
          this[this.type] = v
        },
      },
      showColor () {
        if (typeof this.color === 'string') return this.color

        return JSON.stringify(Object.keys(this.color).reduce((color, key) => {
          color[key] = Number(this.color[key].toFixed(2))
          return color
        }, {}), null, 2)
      },
    },
  }
</script>